import {Component, useEffect} from "react";
import {useLocation, useMatches} from "@remix-run/react";
import * as Sentry from "@sentry/remix";


// Sentry frontend-side
class SentryInit extends Component {
  componentDidMount() {
    const {sentryDsn} = this.props;

    if (process.env.NODE_ENV !== "production") return;

    Sentry.init({
      dsn: sentryDsn,
      integrations: [
        Sentry.browserTracingIntegration({
          useEffect,
          useLocation,
          useMatches,
        }),
      ],
      tracesSampleRate: 0.01,
    });
  }

  render() {
    return null;
  }
}

export default SentryInit
